// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"e337b81c","72":"eff3689d","477":"05e8179b","627":"1f7c6521","663":"fe2ac192","667":"f0d26e72","777":"bbf341a0","803":"92d60b3d","820":"e17b57c8"}[chunkId] + ".chunk.js";
};